export default __webpack_public_path__ + "static/media/arrow-right.d2b5cfa8.svg";